package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class BulkTeamAssessmentResponse(
    val message: String,
    val results: List<BulkTeamAssessmentRequest>,
    val totalPlayers: Long,
)
@Serializable
data class BulkTeamAssessmentRequest(
    @SerialName("playerID")
    val playerId: String,
    val status: String,
)

@Serializable
data class BulkTeamAssessmentPayload(
    @SerialName("coachID")
    val coachId: String,
    val coachEmail: String,
    val coachName: String,
    val organization: String,
    val teams: List<String>,
    val seasonID: String
)
